export default __webpack_public_path__ + "static/measure-057272d1eebd688f118736794af879c3.jpg";